import { render, staticRenderFns } from "./RegulatoryInventory.vue?vue&type=template&id=2ff7e284"
import script from "./RegulatoryInventory.vue?vue&type=script&lang=js"
export * from "./RegulatoryInventory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports